import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    getListInstitution,
    saveInstitution,
    updateInstitution,
    updateSessionConfig,
    deleteInstitution
} from '../actions/InstitutionAction';

export const useInstitutions = () => {
    const queryClient = useQueryClient();

    const { data, isLoading, isError, error, refetch } = useQuery({
        queryKey: ['institutions'],
        queryFn: () => getListInstitution().then(res => res.data),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    const createMutation = useMutation({
        mutationFn: (newInstitution) => saveInstitution(newInstitution).then(res => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['institutions'] });
        },
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, institution }) => updateInstitution(id, institution).then(res => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['institutions'] });
        },
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteInstitution(id).then(res => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['institutions'] });
        },
    });

    const updateSessionConfigMutation = useMutation({
        mutationFn: ({ institutionId, sessionExpirationHours }) =>
            updateSessionConfig(institutionId, sessionExpirationHours).then(res => res.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['institutions'] });
        },
    });

    return {
        institutions: data || [],
        isLoading,
        isError,
        error,
        refetch,
        createMutation,
        updateMutation,
        deleteMutation,
        updateSessionConfigMutation
    };
};
